var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.noData)?_c('div',{staticClass:"wraper"},[_c('img',{staticClass:"image",attrs:{"src":require("../../../../../assets/images/empty.png"),"alt":""}}),_c('div',{staticClass:"des"},[_vm._v("没有找到商品")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }